import axiosInstance from '../../api/axiosInstance';

/**
 * Fetch trial/usage state for the current user's org (from DB: org_plan, cost_tracking).
 * Uses same URL pattern as other APIs so the request hits the backend correctly.
 * @returns {Promise<{ status: string, data?: object }>}
 */
export async function getTrialUsage() {
  try {
    const url = `${process.env.REACT_APP_API_URL || ''}/trial-usage`;
    const response = await axiosInstance.get(url, { withCredentials: true });
    const data = response?.data?.data ?? response?.data;
    if (data && typeof data === 'object') {
      return { status: 'success', data };
    }
    return { status: 'error', data: null };
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('getTrialUsage failed:', error?.response?.status, error?.message);
    }
    return { status: 'error', data: null };
  }
}
